import {AngularFireAuth} from 'angularfire2/auth';
import {AngularFireDatabase, AngularFireList} from 'angularfire2/database';
import {Injectable} from '@angular/core';
import {User} from '../models/user';
import {BaseRepo} from './BaseRepo';

@Injectable()
export class UserRepo extends BaseRepo {
  constructor(protected af: AngularFireAuth, protected db: AngularFireDatabase) {
    super(af);
  }

  getObserver(): AngularFireList<any> {
    return this.getList('users');
  }

  getUserById(id: string) {
    return new Promise((resolve) => {
      const usersObservable = this.db.object(`/users/${id}`);
      const sub = usersObservable.snapshotChanges().subscribe(user => {
        resolve(user);
        sub.unsubscribe();
      });
    });
  }

  getCurrentUser() {
    return new Promise((resolve) => {
      const authDate = this.af.authState.subscribe(userData => {
        const usersObservable = this.db.object(`/users/${userData.uid}`);
        const sub = usersObservable.snapshotChanges().subscribe(user => {
          let userInfo = user.payload.val();
          userInfo.id = user.payload.key;
          resolve(userInfo);
          sub.unsubscribe();
          authDate.unsubscribe();
        });
      });
    });
  }

  update(key: string, data: any) {
    return this.updateObject(`/users/${key}`, data);
  }

  create(user: User) {
    return this.createObject(`/users`, user);
  }
}









// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/DAL/usersRepo.ts